/*! tailwindcss v4.3.3 | MIT License | https://tailwindcss.com */
@layer properties;
.tiptap :first-child {
  margin-top: 0;
}
.tiptap img.ProseMirror-selectednode {
  outline-style: var(--tw-outline-style);
  outline-width: 2px;
  outline-color: hsl(var(--primary));
}
.tiptap p.is-editor-empty:first-child::before, .tiptap p.is-empty::before {
  pointer-events: none;
  float: left;
  height: 0px;
  color: hsl(var(--muted-foreground));
  content: attr(data-placeholder);
}
.tiptap .mention, .tiptap  [data-decoration-id] {
  border-radius: var(--radius-3xl, 1.5rem);
  background-color: hsl(var(--secondary));
  -webkit-box-decoration-break: clone;
  box-decoration-break: clone;
  padding-inline: calc(var(--spacing, 0.25rem) * 2);
  padding-block: 0.2rem;
  color: hsl(var(--secondary-foreground));
}
.tiptap .node-mention {
  border-radius: var(--radius-3xl, 1.5rem);
  padding-block: 0.2rem;
}
.tiptap [data-decoration-id] {
  border-bottom-style: var(--tw-border-style);
  border-bottom-width: 2px;
  --tw-border-style: dotted;
  border-style: dotted;
  border-color: hsl(var(--accent));
  &::after {
    content: var(--tw-content);
    --tw-content: '\00A0';
    content: var(--tw-content);
  }
}
@property --tw-outline-style {
  syntax: "*";
  inherits: false;
  initial-value: solid;
}
@property --tw-border-style {
  syntax: "*";
  inherits: false;
  initial-value: solid;
}
@property --tw-content {
  syntax: "*";
  initial-value: "";
  inherits: false;
}
@layer properties {
  @supports ((-webkit-hyphens: none) and (not (margin-trim: inline))) or ((-moz-orient: inline) and (not (color:rgb(from red r g b)))) {
    *, ::before, ::after, ::backdrop {
      --tw-outline-style: solid;
      --tw-border-style: solid;
      --tw-content: "";
    }
  }
}
